import {RectangleChip} from "../../../../../shared/chip/rectangle-chip.styles";
import {Box} from "@mui/system";

interface EnrollmentStatusProps {
  statusLabel: string;
  statusBackgroundColor: string;
  showEnrollmentStatus: boolean;
}

export const EnrollmentStatus: React.FC<EnrollmentStatusProps> = ({ statusLabel, statusBackgroundColor, showEnrollmentStatus }) => (
  showEnrollmentStatus ?
    <Box>
      <RectangleChip className="spent-chip" sx={{backgroundColor: statusBackgroundColor}}>
        {statusLabel}
      </RectangleChip>
    </Box> : null
);
